import React, {Component} from 'react';
import axios from 'axios';
import cookie from 'react-cookies';
import {Redirect} from 'react-router';
import Navigation from './Navigation';
import Header from './Header';
import Footer from './Footer';
import Select from 'react-select';

import '../App.css';

import Chinese from '../translations/cn';
import English from '../translations/en';
import Japanese from '../translations/jp';
import Korean from '../translations/ko';
import German from '../translations/ge';
import French from '../translations/fr';
import Spanish from '../translations/sp';
import Italian from '../translations/it';
import Russian from '../translations/ru';
import Portuguese from '../translations/po';
import Hindi from '../translations/hi';
import Arabic from '../translations/ar';

export const dictionaryList = {
	English,
	Chinese,
	Japanese,
	Korean,
	German,
	French,
	Spanish,
	Italian,
	Russian,
	Portuguese,
	Hindi,
	Arabic
};

class Currency extends Component{
	constructor(props){
		super(props);

		this.state = {
			dataLanguage: dictionaryList['English'],
			isLogin: false,
			redirect: null,
			selectedCurrency: null,
			selectedTargetCurrency: { value: 0, label: '' },
			defaultCurrency: null,
			orgCurrencyList: [],
			currencyList: [],
			gameCurrencyList: [],
			selectedCurrencyType: { value: 0, label: '' },
			selectedTargetCurrencyType: { value: 0, label: '' },
			tableType: 3,
			currencyTableHeader: null,
			currencyTable: null,
			price: ''
		}

		this.getCurrencyList = this.getCurrencyList.bind(this);
	}
	
	componentWillMount(){
	}

	componentDidMount() {
		if ( cookie.load('cookieId') ) {
			this.setState({
				isLogin: true
			})
		}

		var currencyType = [];
		currencyType.push({ value: 0, label: this.state.dataLanguage['real_world'] });
		currencyType.push({ value: 1, label: this.state.dataLanguage['in_game'] });

		this.setState({
			currencyType: currencyType,
			selectedCurrencyType: { value: 0, label: this.state.dataLanguage['real_world'] },
			selectedTargetCurrencyType: { value: 0, label: this.state.dataLanguage['real_world'] }
		});

		if ( localStorage.getItem('Language') ) {
			this.setState({
				dataLanguage: dictionaryList[localStorage.getItem('Language')]
			});
		} else {
			this.setState({
				dataLanguage: dictionaryList['English']
			});
		}

		this.getCurrencyList();
	}

	getCurrencyList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getCurrencyList')
			.then(response => {
				if ( response.status === 200 ) {
					var currencyList1 = [];
					var currencyList2 = [];
					var temp = null;

					for (var i=0; i<response.data.length; i++) {
						if (response.data[i].type == 1) {
							currencyList1.push({ value: response.data[i].id, label: response.data[i].name });
						} else  {
							currencyList2.push({ value: response.data[i].id, label: response.data[i].name });
						}

						if (response.data[i].status === 2) {
							temp = { value: response.data[i].id, label: response.data[i].name };
						}
					}

					this.setState({
						orgCurrencyList: response.data,
						currencyList: currencyList1,
						gameCurrencyList: currencyList2,
						selectedCurrency: temp,
						selectedTargetCurrency: temp,
						defaultCurrency: temp
					});

					this.makeCurrencyTable();
				}
			})
	}

	setLanguage(lang) {
		this.setState({
			dataLanguage: dictionaryList[lang]
		})
	}

	checkLogin() {
		if ( cookie.load('cookieId') ) {
			this.setState({
				isLogin: true
			})
		} else {
			this.setState({
				isLogin: false
			})
		}
	}

	changeCurrencyHandler = selectedCurrency => {
		this.setState({ 
			selectedCurrency: selectedCurrency
		});
	}

	changeTargetCurrencyHandler = selectedTargetCurrency => {
		this.setState({ 
			selectedTargetCurrency: selectedTargetCurrency,
			targetPrice: 0
		});
	}

	changeCurrencyTypeHandler = selectedCurrencyType => {
		this.setState({ 
			targetPrice: 0,
			selectedCurrencyType: selectedCurrencyType,
			price: '',
			selectedCurrency: this.state.defaultCurrency
		});

		if (selectedCurrencyType.value) {
			this.setState({
				selectedCurrency: null
			})
		}
	}

	changeTargetCurrencyTypeHandler = selectedTargetCurrencyType => {
		this.setState({ 
			targetPrice: 0,
			selectedTargetCurrencyType: selectedTargetCurrencyType,
			selectedTargetCurrency: this.state.defaultCurrency
		});

		if (selectedTargetCurrencyType.value) {
			this.setState({
				selectedTargetCurrency: null
			})
		}
	}	

	changePriceHandler(e) {
		const price = (e.target.validity.valid) ? e.target.value : this.state.price;
		this.setState({ price });
	}

	changeTargetPriceHandler(e) {
		const targetPrice = (e.target.validity.valid) ? e.target.value : this.state.targetPrice;
		this.setState({ targetPrice });
	}

	converteCurrency() {
		if (this.state.selectedCurrency && this.state.selectedTargetCurrency && this.state.price) {
			const fromCurrency = this.state.orgCurrencyList.filter(
				(currency) =>
				currency.id == this.state.selectedCurrency.value
			);

			const toCurrency = this.state.orgCurrencyList.filter(
				(currency) =>
				currency.id == this.state.selectedTargetCurrency.value
			);

			var temp = parseFloat((parseFloat(this.state.price) / parseFloat(fromCurrency[0].rate) * parseFloat(toCurrency[0].rate)).toFixed(6));
			this.setState({
				targetPrice: temp
			})
			
		}
	}

	changeTableType(e) {
		this.setState({
			tableType: e.target.getAttribute('rel')
		}, function(){
			this.makeCurrencyTable();
		})
	}

	makeCurrencyTable() {
		this.setState({
			currencyTable: null
		})

		let records = this.state.orgCurrencyList.map((currency, index) => {
			var type = this.state.tableType;
			if (this.state.tableType == 3) {
				type = 1;
			}
			if ( type == currency.type && currency.id < 25 ) {
				return (
						<div key={index} className="btn_row_out">
							<button className="btn_row">{currency.type == 1 ? currency.symbol : currency.name}</button>
						</div>
					)
			} else {
				return '';
			}
		})
		
		this.setState({
			currencyTableHeader: records
		})

		records = this.state.orgCurrencyList.map((currency, index) => {
			var type = this.state.tableType;
			if (this.state.tableType == 3) {
				type = 2;
			}
			if ( type == currency.type && currency.id < 25 ) {
				let temp = this.state.orgCurrencyList.map((targetCurrency, index) => {
					var type2 = this.state.tableType;
					if (this.state.tableType == 3) {
						type2 = 1;
					}

					if ( type2 == targetCurrency.type && targetCurrency.id < 25 ) {
						var rate = parseFloat((currency.rate / targetCurrency.rate).toFixed(8));
						var classList = "rate";
						// if ( rate > 1 ) {
						// 	classList = "rate red";
						// } else if ( rate < 1 ) {
						// 	classList = "rate gray";
						// }

						if (rate.toString().length > 7) {
							if (15 - rate.toString().length > -1) {
								rate = parseFloat((currency.rate / targetCurrency.rate).toFixed(15 - rate.toString().length));
							}
						}

						return (
								<div key={index} className={classList}>{rate}</div>
							)
					}

					return '';
				})

				return (
						<div key={index} className="col-1">
							<div className="btn_col_out">
								<button className="btn_col">{currency.type == 1 ? currency.symbol : currency.name}</button>
							</div>
							{temp}
						</div>
					)
			} else {
				return '';
			}
		})

		this.setState({
			currencyTable: records
		})

	}

	render(){
		if (this.state.redirect) {
			return <Redirect to={this.state.redirect} />
		}

		const { selectedCurrency } = this.state;
		const { selectedTargetCurrency } = this.state;
		const { selectedCurrencyType } = this.state;
		const { selectedTargetCurrencyType } = this.state;

		const customStyle = {
			control: styles => ({ 
				...styles,
				backgroundColor: 'white',
				color: 'black',
				border: 'solid 3px #ffd33f',
				borderRadius: '30px',
				boxShadow: 'none',
				outline: 'none',
				"&:hover": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				},
				"&:focus": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				}
			}),
			option: (styles, { data, isDisabled, isFocused, isSelected }) => {
				return {
					backgroundColor: isFocused ? '#ddd' : 'white',
					color: isFocused ? 'black' : 'gray',
					padding: '10px',
					size: 5,
					"&:hover": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					},
					"&:focus": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					}
				};
			},
			container: (base, state) => ({
				...base,
				border: state.isFocused ? null : null,
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			}),
			singleValue: (provided, state) => ({
				...provided,
				color: "black",
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			})
		}

		const customStyle2 = {
			control: styles => ({ 
				...styles,
				backgroundColor: 'white',
				color: 'black',
				border: 'none',
				borderRadius: '30px 0 0 30px',
				boxShadow: 'none',
				outline: 'none',
				"&:hover": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				},
				"&:focus": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				}
			}),
			option: (styles, { data, isDisabled, isFocused, isSelected }) => {
				return {
					backgroundColor: isFocused ? '#ddd' : 'white',
					color: isFocused ? 'black' : 'gray',
					padding: '10px',
					size: 5,
					"&:hover": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					},
					"&:focus": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					}
				};
			},
			container: (base, state) => ({
				...base,
				border: state.isFocused ? null : null,
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			}),
			singleValue: (provided, state) => ({
				...provided,
				color: "black",
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			})
		}
		
		return(
			<div className="digit currency">
				<Header history={this.props.history} ref="header" dataLanguage={this.state.dataLanguage} setLanguage={this.setLanguage.bind(this)} checkLogin={this.checkLogin.bind(this)} />
				<div>
					<section className="banner">
						<div className="container">
							<Navigation active="5" dataLanguage={this.state.dataLanguage} history={this.props.history} header={this.refs.header} />
							
							<div className="currency_table">
								<div className="currency_type_buttons">
									<button className={this.state.tableType == 3 ? 'active' : ''} onClick={this.changeTableType.bind(this)} rel='3'>{this.state.dataLanguage['all']}</button>
									<button className={this.state.tableType == 2 ? 'active' : ''} onClick={this.changeTableType.bind(this)} rel='2'>{this.state.dataLanguage['in_game']}</button>
									<button className={this.state.tableType == 1 ? 'active' : ''} onClick={this.changeTableType.bind(this)} rel='1'>{this.state.dataLanguage['real_life']}</button>
								</div>
								<div className="currency_table_content">
									{ this.state.currencyTableHeader ?
										<div className="currency_table_header">
											<div className="btn_col_out"></div>
											{this.state.currencyTableHeader}
										</div>
									: null }
									{ this.state.currencyTable ?
										<div className="currency_table_rows row">
											{this.state.currencyTable}
										</div>
									: null }
								</div>
							</div>
							<div className="currency_converter">
								<div className="title_wrap">
									<h3 className="title text-center text-yellow">{this.state.dataLanguage['currency_converter']}</h3>
								</div>
								<div className="row converter_wrap">
									<div className="col-5">
										<div className="converter_container right">
											<div className="input_wrap">
												<Select styles={customStyle} options={this.state.currencyType} onChange={this.changeCurrencyTypeHandler} value={selectedCurrencyType} />
											</div>
											<div className="input_wrap">
												<div className="twoInput">
													<div className="half">
														{ this.state.selectedCurrencyType.value == 0 ?
															<Select styles={customStyle2} options={this.state.currencyList} onChange={this.changeCurrencyHandler} value={selectedCurrency} />
														:
															<Select styles={customStyle2} options={this.state.gameCurrencyList} onChange={this.changeCurrencyHandler} value={selectedCurrency} />
														}
													</div>
													<div className="half">
														<input type="text" pattern="[0-9.]*" value={this.state.price} onChange={this.changePriceHandler.bind(this)} className="form-control" />
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-2 text-center">
										<img className="converter rotating" onClick={this.converteCurrency.bind(this)} alt="converter" src="/assets/images/converter.png" />
									</div>
									<div className="col-5">
										<div className="converter_container">
											<div className="input_wrap">
												<Select styles={customStyle} options={this.state.currencyType} onChange={this.changeTargetCurrencyTypeHandler} value={selectedTargetCurrencyType} />
											</div>
											<div className="input_wrap">
												{ this.state.selectedTargetCurrencyType.value == 0 ?
													<Select styles={customStyle} options={this.state.currencyList} onChange={this.changeTargetCurrencyHandler} value={selectedTargetCurrency} />
												:
													<Select styles={customStyle} options={this.state.gameCurrencyList} onChange={this.changeTargetCurrencyHandler} value={selectedTargetCurrency} />
												}
											</div>
										</div>
									</div>
								</div>
								<div className="converter_result">
									{ this.state.targetPrice ?
										<p><span className="text-green">{this.state.price}</span> {selectedCurrency.label} = <span className="text-green">{this.state.targetPrice}</span> {selectedTargetCurrency.label}</p>
									: null }
								</div>
							</div>

						</div>
					</section>
				</div>
				<Footer dataLanguage={this.state.dataLanguage} header={this.refs.header} />
			</div>
		)
	}
}

export default Currency;


// WEBPACK FOOTER //
// ./src/components/Currency.js